import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../theme'

export type MenuStyleProps = {
  reduceMenu: boolean
}

export const MenuStyle = styled.div<MenuStyleProps>`
  background: ${colors.primary};
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: column;
  width: ${({ reduceMenu }) => (reduceMenu ? '100px' : '200px')};
  height: 100vh;
  padding: 10px 7px 20px 9px;
`

export const LogoMenu = styled.div<{ isBigMenu: boolean }>`
  margin-top: 0;
  margin-bottom: ${({ isBigMenu }) => (isBigMenu ? '15px' : '25px')};
`

export const Container = styled.div`
  position: absolute;
  background-color: ${colors.surfaceHigh};
  width: 150px;
  height: 105px;
  border-radius: 24px;
  mix-blend-mode: normal;
  bottom: 15px;
`

export const ContainerItems = styled.div<{ isBigMenu: boolean }>`
  margin-top: ${({ isBigMenu }) => (isBigMenu ? '0px' : '10px')};
`

type ButtonType = 'LARGE' | 'SMALL'

export const Button = styled.button<{
  buttonType: ButtonType
  inativarOrganizacaoSim?: boolean
  inativarOrganizacaoNao?: boolean
}>`
  width: ${({ buttonType }) => (buttonType === 'LARGE' ? `400px` : '105px')};
  height: ${({ buttonType }) => (buttonType === 'LARGE' ? `56px` : '25px')};
  padding: ${({ buttonType }) => (buttonType === 'LARGE' ? ` 12px 64px` : '')};

  /* Botao de ACAO: verde de acento. primary virou a cor de chrome (azul
     escuro) e sobre um cartao escuro renderia 1,1:1 — sumiria. So a variante
     destrutiva ("Nao") foge do verde. */
  background-color: ${({ inativarOrganizacaoNao }) =>
    inativarOrganizacaoNao ? colors.error : colors.accentBg};
  border-radius: 100px;
  border: none;
  /* Branco sobre o verde #2aad87 da 2,8:1 e reprova AA — mesma razao do
     ButtonLogin logo abaixo. Sobre o vermelho, o branco fica. */
  color: ${({ inativarOrganizacaoNao }) =>
    inativarOrganizacaoNao ? colors.white : colors.white};
  font-family: 'Poppins';
  font-weight: 600;
  font-size: ${({ buttonType }) => (buttonType === 'LARGE' ? `16px` : '10px')};
  line-height: 150%;
  cursor: pointer;
  margin: 0 auto;
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ButtonLogin = styled.button<{ buttonType: ButtonType }>`
  width: ${({ buttonType }) => (buttonType === 'LARGE' ? `320px` : '25px')};
  padding: ${({ buttonType }) => (buttonType === 'LARGE' ? ` 12px 64px` : '')};
  background-color: ${colors.accentBg};
  border-radius: 15px;
  border: none;
  /* Texto em verde escuro: branco sobre #2AAD87 da 2,8:1 e reprova WCAG AA. */
  color: ${colors.white};
  font-family: 'Poppins';
  font-weight: 600;
  font-size: ${({ buttonType }) => (buttonType === 'LARGE' ? `14px` : '10px')};
  line-height: 150%;
  cursor: pointer;
  margin: 0 auto;
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Article = styled.article`
  color: ${colors.white};
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  -webkit-letter-spacing: 0.2px;
  -moz-letter-spacing: 0.2px;
  -ms-letter-spacing: 0.2px;
  letter-spacing: 0.2px;
  margin: 23px 0px 0px 15px;
`
export const HandsImg = styled.img`
  position: absolute;
  bottom: 80px;
  left: 41px;
  width: 70px;
  height: 70px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

/**
 * Item de menu (link). O `gap` de 10px vale so para o item de PRIMEIRO NIVEL da
 * barra expandida (`$aninhado === false`): ele fica lado a lado com os
 * cabecalhos de secao, que usam 10px — com os 12px dos demais o rotulo
 * comecaria 2px a direita de "Predict"/"Dados". O corpo do texto continua o dos
 * ITENS (11px): o Dashboard e um destino, nao um cabecalho.
 *
 * A regra exclui a barra estreita de proposito: la nao se renderiza rotulo,
 * entao o gap nao tem efeito nenhum — e alcancar aquele caso trocaria a classe
 * de TODOS os itens a toa. Pelo mesmo motivo esta explicacao mora AQUI e nao
 * dentro do template: comentario CSS entra na string gerada e muda o hash da
 * classe de todo mundo. (Crase dentro do template tambem FECHA a string.)
 */
export const LinkStyled = styled(Link)<{
  $isBigMenu?: boolean
  background: string
  /** Item dentro de uma secao: recua para diferenciar do cabecalho do modulo. */
  $aninhado?: boolean
}>`
  text-decoration: none;
  display: ${({ $isBigMenu }) => ($isBigMenu ? 'flex' : 'flex')};
  align-items: center;
  justify-content: ${({ $isBigMenu }) => ($isBigMenu ? 'left' : 'center')};
  cursor: pointer;
  width: ${({ $isBigMenu }) => ($isBigMenu ? '180px' : ' ')};
  gap: ${({ $aninhado, $isBigMenu }) =>
    $aninhado === false && $isBigMenu === true ? '10px' : '12px'};
  height: 42px;
  color: ${colors.white};
  margin-bottom: 5px;
  margin-left: ${({ $isBigMenu }) => ($isBigMenu ? '0px' : '-5px')};
  font-size: 11px;
  border-radius: 8px;
  /* O recuo entra no padding, e nao na largura: a barra tem 184px uteis e o
     item ja ocupa 180px — encolher/deslocar a caixa estouraria a lateral. 18px
     e o maximo que ainda deixa "Mensagens enviadas" numa linha so. */
  padding: 0 8px 0 ${({ $aninhado }) => ($aninhado === true ? '18px' : '10px')};
  background-color: ${({ background }) => background};

  div {
    padding: 10px 10px 8px 0;
    margin-top: -82px;
    border-radius: 8px;
    background-color: ${({ background }) => background};
  }

  :hover {
    /* background-color: ${colors.azulOpaco}; */
  }
`

/**
 * Area rolavel da navegacao.
 *
 * O scroll fica AQUI e nao no `MenuStyle` porque so a LISTA deve rolar: o logo
 * (acima) e o `ContainerItems` (abaixo) ficam parados. Com o menu agrupado por
 * modulos a lista passou a caber menos — em tela de 768px de altura, com as
 * secoes abertas, os ultimos itens ficariam inalcancaveis sem esta rolagem.
 */
export const NavegacaoStyle = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${colors.grey300} transparent;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.grey300};
    border-radius: 3px;
  }
`

/**
 * Normaliza o tamanho do icone. A biblioteca em `assets/icons` tem SVGs de 14
 * a 24px e o menu mistura varios deles — sem isto, `IconDollar` (14) e
 * `CalendarIcon` (20) apareceriam lado a lado com tamanhos visivelmente
 * diferentes, e no menu colapsado o icone e a UNICA informacao do item.
 */
export const IconeMenu = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  svg {
    width: 18px;
    height: 18px;
  }
`

/**
 * Cabecalho de secao (modulo ou grupo generico). E um `button` — e nao um
 * `div` com onClick — porque recolhe e expande conteudo: precisa de foco por
 * teclado e de `aria-expanded`.
 *
 * Tem a mesma altura e o mesmo icone de um item de menu, e nao o rotulo miudo
 * de uma legenda: o nome do MODULO e a informacao principal desta barra, nao
 * uma etiqueta sobre os itens. A hierarquia vem do recuo dos filhos e da seta.
 */
/* Verde de marca quando a rota atual esta dentro da secao — marcador de "voce
   esta aqui" no nivel do modulo; o realce forte (fundo) continua sendo do
   item. Modulo indisponivel apaga, para nao competir com o que se pode usar. */
const corDoTituloSecao = ($ativa: boolean, $indisponivel?: boolean): string => {
  if ($indisponivel === true) {
    return colors.grey500
  }
  return $ativa ? colors.primaryText : colors.white
}

export const SecaoTituloStyle = styled.button<{
  $ativa: boolean
  $indisponivel?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 180px;
  /* min-height, e nao height: "Radar de Churn" mais o selo nao cabem nos 180px
     em uma linha (96px de rotulo + 40px de selo contra 122px uteis), entao a
     linha cresce em vez de recortar o nome do modulo. */
  min-height: 42px;
  margin-bottom: 5px;
  padding: 4px 8px 4px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  line-height: 1.25;
  cursor: ${({ $indisponivel }) =>
    $indisponivel === true ? 'default' : 'pointer'};
  color: ${({ $ativa, $indisponivel }) =>
    corDoTituloSecao($ativa, $indisponivel)};
  font-family: 'Poppins';
  font-size: 12px;
  font-weight: 500;

  svg {
    opacity: ${({ $indisponivel }) => ($indisponivel === true ? '0.6' : '1')};
  }
`

export const SetaSecao = styled.span<{ $aberta: boolean }>`
  display: flex;
  align-items: center;
  margin-left: auto;
  transition: transform 0.15s ease;
  transform: rotate(${({ $aberta }) => ($aberta ? '0deg' : '-90deg')});

  svg {
    width: 12px;
    height: 12px;
  }
`

/**
 * Modulo indisponivel na BARRA COLAPSADA (Radar de Churn, e o Mix de quem nao
 * contratou o modulo). Deliberadamente NAO e um `Link`: nao existe destino para
 * onde ir, e um link que nao navega e pior que um item apagado. Na barra
 * expandida quem faz esse papel e o `SecaoRotuloStyle`, que ainda tem rotulo.
 */
export const ItemBloqueado = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 42px;
  margin-bottom: 5px;
  margin-left: -5px;
  padding: 0 10px;
  border-radius: 8px;
  color: ${colors.grey500};
  font-size: 11px;
  cursor: default;

  svg {
    opacity: 0.65;
  }
`

/**
 * Selo do item indisponivel ("Em breve" / "Conheca"). Usa `surfaceHigh` e nao
 * `azulOpaco` porque `azulOpaco` e o fundo do item ATIVO — repeti-lo aqui faria
 * um item que nao navega parecer o item selecionado.
 */
export const BadgeModulo = styled.span`
  margin-left: auto;
  padding: 2px 5px;
  border-radius: 100px;
  background-color: ${colors.surfaceHigh};
  color: ${colors.grey700};
  /* Sem caixa-alta e em 8px: cada pixel aqui e um pixel a menos para o nome do
     modulo, que nos 180px da barra ja e o aperto. */
  font-size: 8px;
  font-weight: 600;
  white-space: nowrap;
`

/** Separa o bloco dos modulos do bloco das secoes genericas. */
export const DivisorMenu = styled.hr`
  width: 160px;
  height: 1px;
  margin: 10px 0;
  border: none;
  background-color: ${colors.grey300};
  opacity: 0.5;
`

/**
 * Mesma aparencia do cabecalho, sem interacao. Usado na secao que nao recolhe
 * (modulo sem nenhuma tela acessivel): um `button` que nao faz nada prometeria
 * um clique que nao existe.
 */
export const SecaoRotuloStyle = SecaoTituloStyle.withComponent('div')
